// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mllModal__modal___7prdj{height:220px}.mllModal__modalBody___1mmY5{padding:0;width:100%;height:100%;display:flex;flex-direction:column}.mllModal__header___GKN4g{flex-shrink:0;height:45px;display:flex;align-items:center;justify-content:center;border-bottom:.5px solid #e9eff5;position:relative}.mllModal__headerBackButton___lmcml{color:#717070;position:absolute;left:5px;cursor:pointer;display:flex;align-items:center}.mllModal__headerBackButton___lmcml:hover{background-color:rgba(118,118,118,.1)}.mllModal__mllOptions___UH-cR{flex-grow:1;overflow-y:auto;padding-bottom:30px}.mllModal__mllOption___37URi{border-bottom:.5px solid #e9eff5;color:var(--primary-button-background-color);background-color:#fff;text-align:center;cursor:pointer;position:relative;height:45px;display:flex;justify-content:center;align-items:center;padding:0 15px}.mllModal__mllOption___37URi:hover{background-color:#f3f5f8}.mllModal__label___n8u14{flex-grow:1}.mllModal__mllChevron___FPykN{color:#717070;position:absolute;right:5px;top:25%}html[dir=\"rtl\"] .mllModal__headerBackButton___lmcml{right:5px;left:initial;transform:rotate(180deg)}html[dir=\"rtl\"] .mllModal__mllChevron___FPykN{left:5px;right:initial;transform:rotate(180deg)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"white": "#fff",
	"primary": "#222",
	"secondary": "#717070",
	"primaryBlue": "#336dec",
	"primaryDarkerBlue": "#005bcc",
	"chatIconFrameWidth": "70px",
	"chatIconFrameHeight": "70px",
	"widgetFrameWidth": "400px",
	"widgetFrameHeight": "650px",
	"mobileScreenWidth": "550px",
	"mobileScreenHeight": "655px",
	"modal": "mllModal__modal___7prdj",
	"modalBody": "mllModal__modalBody___1mmY5",
	"header": "mllModal__header___GKN4g",
	"headerBackButton": "mllModal__headerBackButton___lmcml",
	"mllOptions": "mllModal__mllOptions___UH-cR",
	"mllOption": "mllModal__mllOption___37URi",
	"label": "mllModal__label___n8u14",
	"mllChevron": "mllModal__mllChevron___FPykN"
};
export default ___CSS_LOADER_EXPORT___;
